/* eslint-disable */
// because legacy

import { notifications } from '@bikemap/js/services'


$(function() {
  "use strict"

  $.outdoorish.forms = $.outdoorish.forms || {}

  /* ******************* Handle form errors ******************** */
  $.outdoorish.forms.handleAjaxFormErrors = function(jqxhr, textStatus) {
    var $busyElement

    var busyClass

    var keepBusy = false
    if (this.busyElement !== undefined && this.busyClass !== undefined) {
      $busyElement = this.busyElement
      busyClass = this.busyClass
    }
    if (textStatus === "success") {
      var data = JSON.parse(jqxhr.responseText)

      var $form

      if (this.form === undefined) {
        $form = $("form#" + data.action)
      } else {
        $form = this.form
      }

      $(".form-global-error", $form).remove()
      $(".form-field-error", $form).remove()

      if (data.success) {
        // If we have a redirect url, redirect to it
        var callback = this.formSuccessCallback
        if (data.url) {
          keepBusy = true
          if (callback !== undefined) {
            callback(data.callback_params, data.url)
          } else if (location.href === data.url) {
            location.reload()
          } else {
            location.href = data.url
          }
        } else if (callback !== undefined) {
          callback(data.callback_params)
        }
        if (this.keepBusy !== undefined) {
          keepBusy = this.keepBusy
        }
      } else {
        $form.addClass("error")
        for (var i in data.errors) {
          if (Object.prototype.hasOwnProperty.call(data.errors, i)) {
            var err = data.errors[i]

            if (err[0] === "__all__") {
              $form.prepend('<p class="form-global-error">' + err[1] + "</p>")
            } else {
              var $field
              if (err[0].indexOf("__id__") === -1) {
                $field = $('[name^="' + err[0] + '"]:last', $form)
              } else {
                $field = $("#" + err[0].split("__id__")[1], $form)
              }

              if ($field.attr("type") !== "hidden") {
                $field.closest(".form-field").addClass("error")
                $field.addClass("error")

                // eslint-disable-next-line max-depth
                if (
                  $field.parent().is("div") &&
                  ($field[0].nextElementSibling === null ||
                    !$field[0].nextElementSibling.classList.contains(
                      "input-group-addon"
                    ))
                ) {
                  $field.after('<p class="form-field-error">' + err[1] + "</p>")
                } else {
                  var errorHTMLElementString

                  // eslint-disable-next-line max-depth
                  if ($field.parent().css("display") === "table-cell") {
                    errorHTMLElementString =
                      '<p class="form-field-error" style="display: table-row;">' +
                      err[1] +
                      "</p>"
                  } else {
                    errorHTMLElementString =
                      '<p class="form-field-error">' + err[1] + "</p>"
                  }
                  $field.parent().after(errorHTMLElementString)
                }
              }
            }
          }
        }
      }
    } else if (textStatus === "error") {
      notifications.close()
      if (jqxhr.responseJSON) {
        notifications.show({
          title: jqxhr.responseJSON.title || django.gettext("Error") + ": " + jqxhr.statusText,
          icon: "i-warning-sign",
          message: jqxhr.responseJSON.message || django.gettext(
            "There was an unexpected error. We are sorry! Please try again!"
          ),
          type: "danger"
        })
      } else {
        notifications.error(jqxhr.statusText)
      }
    }

    if ($busyElement !== undefined && keepBusy === false) {
      $busyElement.prop("disabled", false).removeClass(busyClass)
    }
  }

  // eslint-disable-next-line max-params
  $.outdoorish.forms.formFieldValidation = function(
    $field,
    $form,
    $submitElement,
    url,
    ajaxRequest,
    timeout,
    extraRequestData,
    validationCallback
  ) {
    $submitElement.prop("disabled", true).addClass("loading-spinner")
    var requestData = { fieldValue: $field.val() }

    if (extraRequestData !== undefined) {
      $.extend(requestData, extraRequestData)
    }

    if (ajaxRequest !== null) {
      ajaxRequest.abort()
    }

    if (timeout !== null) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(function() {
      ajaxRequest = $.ajax({
        url: url,
        method: "POST",
        data: requestData,
        headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
        success: function(data) {
          $field.next(".form-field-error").remove()
          $field.closest(".form-field").removeClass("error")
          $field.removeClass("error")

          if (data.success === false) {
            $field.closest(".form-field").addClass("error")
            $field.addClass("error")

            var errorText =
              '<p class="form-field-error">' + data.message + "</p>"

            if (
              $field.parent().hasClass("input-group") &&
              ($field[0].nextElementSibling === null ||
                $field[0].nextElementSibling.classList.contains(
                  "input-group-addon"
                ))
            ) {
              $field.parent().after(errorText)
            } else {
              $field.after(errorText)
            }
          } else {
            $submitElement.prop("disabled", false)
          }

          if (validationCallback !== undefined) {
            validationCallback(data)
          }
        },
        error: function() {
          $submitElement.prop("disabled", false)
        },
        complete: function() {
          $submitElement.removeClass("loading-spinner")
        }
      })
    }, 500)

    return { timeout: timeout, ajaxRequest: ajaxRequest }
  }
})
